import { FunctionComponent } from "react";

import * as Styled from "./styles";

interface ProgressBarProps {
  progress: number;
}

const ProgressBar: FunctionComponent<ProgressBarProps> = ({ progress }: ProgressBarProps) => {
  return (
    <Styled.ProgressBarContainer>
      <Styled.ProgressBarDiv $progress={progress * 100} />
    </Styled.ProgressBarContainer>
  );
};

export default ProgressBar;
